<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'form.documents' | translate }}
            </h3>

            <p>{{ 'full-data.inversis.documentation' | translate }}</p>
            <ng-container *ngIf="hasRisk">
                <p>{{ 'full-data.inversis.risk-header' | translate }}</p>
                <ul>
                    <li *ngIf="hasProfessionalRisk">
                        {{ 'full-data.inversis.risk-notice-1' | translate: { name: client.fullName } }}
                    </li>
                    <li *ngIf="hasCountryRisk">
                        {{ 'full-data.inversis.risk-notice-2' | translate: { name: client.fullName } }}
                    </li>
                    <li *ngIf="hasPublicFunctions">
                        {{ 'full-data.inversis.risk-notice-3' | translate: { name: client.fullName } }}
                    </li>
                    <li *ngIf="isInvestmentHigh">
                        {{ 'full-data.inversis.risk-notice-4' | translate }}
                    </li>
                </ul>
                <p>{{ 'full-data.inversis.risk-footer' | translate }}</p>
            </ng-container>

            <ng-template ngFor let-document [ngForOf]="client.documentsInversis" let-i="index">
                <div class="my-3 mb-sm-4">
                    <thr-file-selector [name]="'fdpDocument' + i" [label]="document.name" [filename]="document.filename" [canView]="document.id && !document.file" filesize [maxSize]="maxSize" filetype [allowedTypes]="allowedTypes" [allowedExtension]="allowedExtension" [required]="!document.optional && (!document.id || document.remove)"
                        [disabled]="isDisabled" [(ngModel)]="document.file" (view)="onDocumentView(document)" (remove)="onDocumentRemove(document)" #documentCtrl="ngModel"></thr-file-selector>
                    <mat-hint class="d-block mat-caption font-italic mt-2 text-blue" *ngIf="documentCtrl.valid">
                        {{ 'form.documents-help-zip' | translate: { size: 25 } }}
                    </mat-hint>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('filetype') && !documentCtrl.hasError('required')">
                        {{ 'form.validation.filetype' | translate }}
                    </mat-error>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('filesize') && !documentCtrl.hasError('required')">
                        {{ 'form.validation.filesize' | translate: { size: 25 } }}
                    </mat-error>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </div>
            </ng-template>
        </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isDisabled && !isDisabledSubmit">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                {{ 'general.save' | translate }}
            </button>
        </div>
    </div>
</ng-container>
